import { Injectable } from '@angular/core';
import { Action, Selector, State, StateContext } from "@ngxs/store";
import { EMPTY } from "rxjs";
import { tap } from "rxjs/operators";
import { patch, removeItem } from "@ngxs/store/operators";
import { BaseTestItemDto } from "src/app/models/dto/Base-Test-item-dto";
import { SpecificationCoverageApiService } from "src/app/services/api/specification-coverage-api.service";
import { SpecificationCoverageActions } from "./specificationCoverage.actions";
import { SpecificationCoverageStateModel } from "./specificationCoverage.state.model";

@State<SpecificationCoverageStateModel>({
    name: 'specificationCoverage',
    defaults: {
        specificationCoverages: [],
        mySpecificationCoverages: []
    },
})
@Injectable()
export class SpecificationCoverageState {
    constructor(private secificationCoverageApiService: SpecificationCoverageApiService) {}

  @Action(SpecificationCoverageActions.SetAllSpecificationCoverages)
  SetAllSpecificationCoverages(ctx: StateContext<SpecificationCoverageStateModel>) {
    const state = ctx.getState();
    //don't update state if we have already downloaded items
    if (state.specificationCoverages !== undefined && state.specificationCoverages.length > 0) return EMPTY;

    return this.secificationCoverageApiService.getAll('').pipe(
      tap(specCoverages => {
        ctx.patchState({ specificationCoverages: specCoverages });
      })
    );
  }

  @Action(SpecificationCoverageActions.SetMySpecificationCoverages)
  SetMySpecificationCoverages(ctx: StateContext<SpecificationCoverageStateModel>, action: SpecificationCoverageActions.SetMySpecificationCoverages) {
    const state = ctx.getState();
    //don't update state if we have already downloaded items
    if (state.mySpecificationCoverages !== undefined && state.mySpecificationCoverages.length > 0) return EMPTY;

    return this.secificationCoverageApiService.getAll(action.userId).pipe(
      tap(specCoverages => {
        ctx.patchState({ mySpecificationCoverages: specCoverages });
      })
    );
  }

  @Action(SpecificationCoverageActions.DeleteSpecificationCoverage)
  DeleteSpecificationCoverage(ctx: StateContext<SpecificationCoverageStateModel>, action: SpecificationCoverageActions.DeleteSpecificationCoverage){
    return this.secificationCoverageApiService.delete(action.specificationCoverageUid, action.regBy).pipe(
      tap(() =>{
        ctx.setState(
          patch<SpecificationCoverageStateModel>({
            specificationCoverages: removeItem<BaseTestItemDto>(x => x.uid === action.specificationCoverageUid),
            mySpecificationCoverages: removeItem<BaseTestItemDto>(x => x.uid === action.specificationCoverageUid)
          })
        )
      })
    );
  }
  
  @Action(SpecificationCoverageActions.UpdateItem)
  updateItem(ctx: StateContext<SpecificationCoverageStateModel>, action: SpecificationCoverageActions.UpdateItem) {
    const state = ctx.getState();

    // Update in specificationCoverages
    const allIdx = state.specificationCoverages.findIndex(item => item.uid === action.item.uid);
    if (allIdx >= 0) {
      const updated = [...state.specificationCoverages];
      updated[allIdx] = action.item;  // Full replace - action.item is already complete
      ctx.patchState({ specificationCoverages: updated });
    }

    // Update in mySpecificationCoverages
    const myIdx = state.mySpecificationCoverages.findIndex(item => item.uid === action.item.uid);
    if (myIdx >= 0) {
      const updated = [...state.mySpecificationCoverages];
      updated[myIdx] = action.item;  // Full replace - action.item is already complete
      ctx.patchState({ mySpecificationCoverages: updated });
    }
  }

  @Action(SpecificationCoverageActions.ClearCache)
  clearCache(ctx: StateContext<SpecificationCoverageStateModel>) {
    ctx.patchState({
      specificationCoverages: [],
      mySpecificationCoverages: []
    });
  }

  @Selector()
  static getAllSpecificationCoverages(state: SpecificationCoverageStateModel) {
    return state.specificationCoverages;
  }
  @Selector()
  static getMySpecificationCoverages(state: SpecificationCoverageStateModel) {
    return state.mySpecificationCoverages;
  }
}